<div class="canned-service-browse-content">
  <!-- Internal services header -->
  <div class="content-header flex-between-center">
    <p class="mb-0 font-12 font-bold">Deferred Service</p>

    <div class="default-cursor flex-start-center" [ngStyle]="{'width': isSubletTrackingEnabled ? '593px' : ''}">
      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Labor</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Part</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Tire</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Fee</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1" *ngIf="isSubletTrackingEnabled">
        <span class="font-600">Sublet</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Other</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-2">
        <span class="font-600">Subtotal</span>
      </div>

      <div class="font-11 pointer font-600 add-est-btn text-center btn-60">
        Add to {{orderStatus}}
      </div>
      <div class="font-11 pointer font-600 text-center">
        <span class="opacity-0">
          action
        </span>
      </div>
    </div>
  </div>

  <!-- Internal service list -->
  <div class="canned-service">
    <app-accordian id="canned-service" *ngFor="let service of visibleDeferredServices; let serviceIndex = index"
      [data]="service" listItemKey="items" listItemLabel="title" listItemIdKey="sitemId" [hasItemCheckbox]="true"
      [iconSize]="10" [fontSize]="12" [index]="serviceIndex" [hasCustomHeader]="true" [hasAccordianSubItem]="true"
      [hasAccordianSubItemInspection]="!!service?.inspection?.inspectionId"
      [inspectionChecked]="!!selectedServiceInspection[service._id]"
      (handleItemSelectChange)="handleSelectChange($event)"
      (handleInspectionItemSelectChange)="handleInspectionSelectChange($event, service)">
      <!-- Service header -->
      <ng-template appTemplate="accordian-header" let-selectAll="selectAll">
        <div class="flex-between-center service-acc-header" (click)="addToEstmate(service, selectAll, $event )">
          <div class="flex-center-center">
            <p class="font-13 font-600 browse-title m-0 flex-column"
              tooltipStyleClass="ticket-tooltip modifier services-size deferred-ro completed"
              [pTooltip]="service.tooltipDeferred" [escape]="false" tooltipPosition="top">
              <span>{{service?.title}}</span>
              <span class="font-11">
                Last
                <span class="font-primary" (click)="handleROLinkClick(service?.estimate?.estimateId)">
                  RO#{{service?.estimate?.estimateCode}}
                </span>
              </span>
            </p>
          </div>

          <div class="default-cursor flex-start-center">
            <!-- Labor -->
            <div class="flex-center-start font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.labor | currency: usd }}
              </span>
              <span class="flex-center-center">
                <i class="far fa-clock fa-icon-light-gray pr-2"></i>
                {{service?.extra?.hours || 0| number : '1.2-2' }}
              </span>
            </div>

            <!-- Part -->
            <div class="flex-center-start font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.part | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-tools fa-icon-light-gray pr-2"></i>
                {{service?.extra?.parts || 0 | number : '1.2-2'}}
              </span>
            </div>

            <!-- Tire -->
            <div class="flex-center-start font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.tire | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-tire fa-icon-light-gray pr-2"></i>
                {{service?.extra?.tires || 0 | number : '1.2-2'}}
              </span>
            </div>


              <!-- Fee -->
              <div class="flex-center-start font-12 m-width-65 flex-column mr-1">
                <span>
                  {{ service?.serviceTotal?.fee | currency: usd }}
                </span>
  
                <span class="flex-center-center">
                  <i class="far fa-tire fa-icon-light-gray pr-2"></i>
                  {{service?.extra?.fees || 0 | number : '1.2-2'}}
                </span>
              </div>

            <!-- Sublet -->
            <div class="flex-center-start font-12 m-width-65 flex-column mr-1" *ngIf="isSubletTrackingEnabled">
              <span>
                {{ service?.serviceTotal?.sublet || 0 | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-store 1 fa-icon-light-gray pr-2"></i>
                {{service?.extra?.sublet || 0 | number : '1.2-2'}}
              </span>
            </div>

            <!-- Other -->
            <div class="flex-center-start font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.other | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-stream 1 fa-icon-light-gray pr-2"></i>
                {{service?.extra?.other || 0 | number : '1.2-2'}}
              </span>
            </div>

            <div class="flex-center-start font-12 m-width-65 flex-column mr-3">
              <span>
                {{ service?.serviceTotal?.total | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-ballot-check fa-icon-light-gray pr-2"></i>
                {{!!service?.inspection?.inspectionId ? 1 : 0}}
              </span>
            </div>

            <div *ngIf="selectedInternalServices[service?._id]" id="btn-selected-est{{serviceIndex}}"
              class="font-11 pointer add-est-btn btn-gray text-center btn-60">
              Selected
            </div>

            <div *ngIf="!selectedInternalServices[service?._id]" id="btn-add-est{{serviceIndex}}"
              class="font-11 pointer add-est-btn btn-white text-center btn-60">
              Add
            </div>

            <i class="far fa-times-circle font-gray-45 p-2 pointer"
              [ngClass]="{'not-allowed': selectedInternalServices[service?._id]}"
              [pTooltip]="selectedInternalServices[service?._id]? 'Please unselect service first': ''"
              (click)="handleDeleteDeferredService($event, service?._id)"></i>
          </div>
        </div>
      </ng-template>

      <ng-template appTemplate="accordian-sub-item" let-item let-checkboxId="checkboxId">
        <label class="flex-between-center width-100p mb-0 pointer" [for]="checkboxId">
          <div class="font-12">{{item.title}}</div>

          <div class="flex-column mr-2">
            <div class="font-12 text-right font-600 font-gray">
              {{ item.total | currency: usd }}
            </div>

            <div class="font-9 text-right font-gray">{{item.quantity}}</div>
          </div>
        </label>
      </ng-template>

      <ng-template appTemplate="accordian-sub-item-inspections" let-item let-checkboxId="checkboxId">
        <label class="flex-between-center width-100p mb-0 pointer" [for]="checkboxId">
          <div class="font-12">{{service?.inspection?.title}}</div>

          <div class="flex-column mr-2">
            <div class="font-12 text-right font-600 font-gray">
              {{service?.inspectionCount?.categoryCount}}
              {{service?.inspectionCount?.categoryCount > 1 ? 'Categories' : 'Category'}}
            </div>

            <div class="font-9 text-right font-gray">
              {{service?.inspectionCount?.itemCount}}
              {{service?.inspectionCount?.itemCount > 1 ? 'Items' : 'Item'}}
            </div>
          </div>
        </label>
      </ng-template>
    </app-accordian>
  </div>
  <!-- Canned Service List -->
</div>
